module.exports = __webpack_public_path__ + "img/nav-design-fancy@2x.04ae1dc.jpg";